// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XCsP","title":"Header_title__2DQA2","left":"Header_left__2FUye","clinicName":"Header_clinicName__32Nq4"};